import { useMemo } from "react";
import { availabilityMarksRef } from "../lib/data/availability";
import { useFirestoreCollection } from "./useFirestoreCollection";

/**
 * Real-time subscription to a user's authored availability marks.
 * Returns { data, loading, error } from useFirestoreCollection. Each
 * mark in `data` carries its Firestore doc id at `id`. No-op when uid
 * is falsy.
 */
export function useAvailabilityMarks(uid) {
  const queryRef = useMemo(
    () => (uid ? availabilityMarksRef(uid) : null),
    [uid]
  );
  return useFirestoreCollection(queryRef);
}
